var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 14 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#367C2B",
    d: "M4.75 8.127 1.622 5 .557 6.057 4.75 10.25l9-9L12.693.192z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCheck);
export default __webpack_public_path__ + "static/media/passwordCheck.d46b8449f9bff754ce8e1002056d5b49.svg";
export { ForwardRef as ReactComponent };